import { ArrowNarrowLeftIcon } from '@heroicons/react/outline'
import { CheckCircleIcon, UsersIcon } from '@heroicons/react/solid'
import { useFormikContext } from 'formik'
import Button from 'shared/components/base/button/BaseButton'
import FormikCheckbox from 'shared/components/formik/Checkbox'

type Props = {
  handleFactorTarkibiButtonClick?: () => void
  hasOtherRequest?: boolean
  disableSubmitButton?: boolean
  submitButtonLabel?: string
  disabledCombinedConnection?: boolean
}

const SubmitButtons = ({
  handleFactorTarkibiButtonClick,
  hasOtherRequest,
  disableSubmitButton,
  submitButtonLabel,
}: Props) => {
  const { isSubmitting, submitForm } = useFormikContext()

  return (
    <div className="flex items-center justify-end w-full mt-5 lg:mr-auto">
      {hasOtherRequest && (
        <FormikCheckbox
          name={'shouldResetForm'}
          className="w-[unset]"
          inputClassName="w-[16px] h-[16px]"
          label={
            <div className="text-[13px] text-[#939597] font-medium xl:mt-[6px] mr-[7px]   ">
              این کاربر درخواست دیگری هم دارد.
            </div>
          }
        />
      )}
      <div className="mr-auto" />
      {handleFactorTarkibiButtonClick && (
        <Button
          type="button"
          className="!bg-transparent text-red-light "
          onClick={handleFactorTarkibiButtonClick}
          rightIcon={<UsersIcon className="inline w-6 h-6 " />}
          leftIcon={<ArrowNarrowLeftIcon className="inline w-6 h-6" />}
        >
          ترکیبی و اتصال به بعدی
        </Button>
      )}
      <Button
        className="!px-9 h-[52px] bg-red-light text-[14px] font-semibold text-white rounded-2 mr-[50px]"
        rightIcon={<CheckCircleIcon className="w-5 h-5" />}
        type="submit"
        color="red"
        loading={isSubmitting}
        onClick={submitForm}
        disabled={disableSubmitButton}
      >
        {submitButtonLabel}
      </Button>
    </div>
  )
}

export default SubmitButtons
